import { Link } from 'react-router-dom'
import { t } from '../i18n.ts'

export function NotFound() {
  return (
    <div className="page" style={{ padding: 'var(--space-6) var(--space-4)' }}>
      <h1>{t.concert.notFound}</h1>
      <p style={{ color: 'var(--text-muted)' }}>{t.concert.notFoundHelp}</p>
      <Link to="/">{t.nav.toProgram}</Link>
    </div>
  )
}
